<template>
  <property-compare
    v-if="!reportLoading"
    is-sample-view
    :comparable-addresses="sample.comparable_addresses"
    :subject="sample.subject"
    :report="sample"
  >
    <template #primay-button="{ hasPropertyReports }">
      <div v-if="hasPropertyReports && canCreatePropertyReports">
        <q-tooltip v-if="userUsageLimitReached" max-width="280px">
          {{ userUsageHelpText }}
        </q-tooltip>
        <q-btn
          id="sample-report-cta"
          color="primary"
          no-caps
          unelevated
          :to="userUsageLimitReached ? undefined : { name: 'New Property Report' }"
          :disable="userUsageLimitReached"
          @click="clickedCreateOwnReport"
        >
          <q-icon name="add" class="q-mr-sm" />New Report
        </q-btn>
      </div>
      <q-btn
        v-else-if="!hasPropertyReports"
        no-caps
        unelevated
        color="primary"
        :to="{ name: 'Subscribe to Property Reports' }"
      >
        7-Day Free Trial
      </q-btn>
    </template>
  </property-compare>
</template>
<script lang="ts">
import { type PropType } from 'vue'
import PropertyCompare from '@/components/PropertyReports/PropertyCompare.vue'
import type { PropertyReportSubscriptionAttributes } from 'common'
import { usePropertyReportStore } from '@/stores/propertyreport'
import { useUserStore } from '@/stores/user'

export default {
  name: 'PropertyReportsSample',
  components: { PropertyCompare },
  props: {
    sample: {
      required: true,
      type: Object as PropType<PropertyReportSubscriptionAttributes>
    }
  },
  data() {
    return {
      reportLoading: false,
      report: null as PropertyReportSubscriptionAttributes | null
    }
  },
  computed: {
    canCreatePropertyReports() {
      return useUserStore().canCreatePropertyReports
    },
    userUsageLimitReached() {
      return useUserStore().userUsageLimitReached
    },
    userUsageHelpText() {
      return useUserStore().userUsageHelpText
    }
  },
  watch: {
    sample() {
      this.loadReport()
    }
  },
  methods: {
    clickedCreateOwnReport() {
      this.$tracker.clickedNewReportButton('sample_report')
    },
    loadReport() {
      usePropertyReportStore().cleanReportData()
      this.reportLoading = true
      this.$nextTick(() => {
        this.reportLoading = false
      })
    }
  }
}
</script>
